module.exports = __webpack_public_path__ + "media/sf_cartoon_ohoh_01.18efb9a0.mp3";